module.exports = __webpack_public_path__ + "images/img-26mpCkF.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/ranks/4.jpg
// module id = 2031
// module chunks = 0